import { useBehaviorSubject } from '@talos/kyoko';
import { useMemo } from 'react';
import { map } from 'rxjs';
import type { ModifyFixingEntry } from './modifyFixingSlice';

export const useModifyFixingBlotterDataObs = (entries: ModifyFixingEntry[]) => {
  const { observable: entriesObs } = useBehaviorSubject(() => entries, [entries]);

  return useMemo(
    () =>
      entriesObs.pipe(
        map(currentEntries => ({
          initial: true,
          data: currentEntries,
        }))
      ),
    [entriesObs]
  );
};
